<template>
  <span class="relate-chain-wrapper" :class="id?'case':''">
    <el-button v-if="!chainDate" size="small" disabled type="text">关联至编链</el-button> 
    <el-popover placement="bottom" width="370" trigger="manual" :popper-class="docType ? 'relate-chain-popper':''"
      v-model="visiblePop">
      <div>
        <el-form label-width="160px" label-suffix="：" size="mini">
          <el-form-item :label="chainTimeText" style="margin-bottom:10px">
            <span>{{chainDate}}</span>
          </el-form-item>
          <el-form-item label="选择编链时间">
            <el-select v-model="schemeTimeAxisId" size="mini" placeholder="请选择" style="width:100%">
              <el-option v-for="(item,index) in timeAxisList" :key="index" :label="item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div style="text-align: center; margin: 0">
        <el-button size="mini" @click="visiblePop = false">取消</el-button>
        <el-button type="primary" size="mini" @click="handleLinkToScheme">确定</el-button>
      </div>
      <!-- 疗管||病人管理判断是否关联之编链逻辑 -->
      <template v-if="id">
        <el-button v-if="!axisName" size="small" slot="reference" type="text" @click="clickRelateBtn">关联至编链</el-button>
        <el-button v-else size="small" slot="reference" type="text" @click="clickRelateBtn">重新关联</el-button>
      </template>
      <template v-else>
        <el-button v-if="chainDate && !chainRelateArr.length" size="small" slot="reference" type="text"
          @click="clickRelateBtn">关联至编链</el-button>
        <el-button v-if="chainRelateArr.length" size="small" slot="reference" type="text"
          @click="clickRelateBtn">重新关联</el-button>
      </template>
    </el-popover> 
  </span>
</template>
<script>
import local from "@/utils/local.js";
import { linkToScheme, getRunTimeAxisList } from "@/api/crossreentry";
export default {
  props: {
    chainDate: {
      type: String
    },
    chainTimeText: {
      type: String
    },
    eventName: {
      type: String
    },
    docType: {
      type: Number,
      default: null
    },
    patientFilesId: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    axisName: {
      //疗管病例信息-病人管理 判断是否已关联至编链
      type: String,
      default: ""
    },
    dateName: {
      //时间枚举值
      type: String,
      default: ""
    }
  },
  data() {
    return {
      chainRelateArr: [], 
      visiblePop: false, 
      timeAxisList: [], 
      flag: "",
      linkValue: "",
      schemeTimeAxisId: "",
      mark: 0
    };
  },
  watch: {
    patientFilesId() {
      this.getTimeAxisListData();
    }
  },
  async created() {
    // this.getTimeAxisListData()
  },
  mounted() {},
  methods: {
    clickRelateBtn() {
      this.visiblePop = true;
      this.schemeTimeAxisId = "";
      this.getTimeAxisListData();
    },
    async handleLinkToScheme() {
      let res = await linkToScheme({
        flag: 1,
        linkColumnName: this.chainTimeText,
        linkValue: this.chainDate,
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
        schemeTimeAxisId: this.schemeTimeAxisId,
        eventName: this.eventName,
        docType: this.docType,
        patientFilesId: this.patientFilesId,
        historyId: this.id,
        dateName: this.dateName
      });
      if (res.code === 0) { 
        this.$message.success("保存成功");
        this.visiblePop = false;
        if (this.id) {
          this.$emit("toUpTime");
        }
        // 刷新当前关联结果
        this.getTimeAxisListData();
      }
      if (res.code === 320072) {
        this.mark = 2;
        // return
        let tipsMsg = res.message;
        this.$confirm(tipsMsg, "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        }).then(async () => {
          await this.handleRepeatLink();
        });
      }
    },
    async handleRepeatLink() {
      let res = await linkToScheme({
        flag: this.mark,
        linkColumnName: this.chainTimeText.split(":")[0],
        linkValue: this.chainDate,
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
        schemeTimeAxisId: this.schemeTimeAxisId,
        eventName: this.eventName,
        docType: this.docType,
        patientFilesId: this.patientFilesId,
        historyId: this.id,
        dateName: this.dateName
      });
      if (res.code === 0) {
        this.$message.success("保存成功");
        this.visiblePop = false;
        if (this.id) {
          this.$emit("toUpTime");
        }
        // 刷新当前关联结果
        this.getTimeAxisListData();
      }
    },
    async getTimeAxisListData() {
      let res = await getRunTimeAxisList({
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId
      });
      if (res.code === 0) {
        this.chainRelateArr = res.data.filter(
          v =>
            v.docType == this.docType &&
            v.eventName == this.eventName &&
            v.linkColumnName == this.chainTimeText &&
            v.patientFilesId == this.patientFilesId
        );
        if (this.id) {
          if (!this.axisName) {
            this.schemeTimeAxisId = "";
          } else {
            if (this.chainRelateArr.length) {
              this.schemeTimeAxisId = this.chainRelateArr[0].id;
            }
          }
        } else {
          if (this.chainRelateArr.length) {
            this.schemeTimeAxisId = this.chainRelateArr[0].id;
          }
        }

        this.timeAxisList = res.data;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.relate-chain-wrapper {
  margin-left: 10px;
}
.case {
  margin-left: 0;
}
</style>
<style>
.relate-chain-popper {
  left: -220px;
  top: 3px;
  padding: 2px 12px !important;
}
</style>
